<template>
  <div class="student-list">
    <el-dialog
      title="标签绑定的学生列表"
      :visible.sync="tagBindStudentListDialogShow"
      width="40%"
      :before-close="handleClose"
    >
      <el-table :data="tagBindStudentList" style="width: 100%; max-height: 400px; overflow-y: auto;">
        <el-table-column prop="studentName" label="姓名"> </el-table-column>
        <el-table-column prop="studentNumber" label="学号"> </el-table-column>
        <el-table-column prop="gradeName" label="年级"> </el-table-column>
        <el-table-column prop="className" label="班级"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["tagBindStudentListDialogShow", "tagBindStudentList"],
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("update:tagBindStudentListDialogShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./bindStudentListDialog.scss";
</style>